import { downloadData } from 'aws-amplify/storage';
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
} from 'react';

const Context = createContext({});

export default function GeneralSettingProvider({ children }) {
  const [generalSetting, setGeneralSetting] = useState();
  useEffect(() => {
    getGeneralSetting();
  }, [])

  const getGeneralSetting = async () => {
    try {
      const { body } = await downloadData({ key: 'setting/general_setting.json' }).result;
      const setting = JSON.parse(await body.text());
      setGeneralSetting(setting);
      document.title = setting.appTitle || 'エネルギーポール機器監視システム';
    }
    catch (e) {
      console.error("ERROR", e);
    }
  }

  return (
    <Context.Provider value={{ generalSetting, setGeneralSetting }}>
      {children}
    </Context.Provider>
  );
}

export const useGeneralSetting = () => useContext(Context);
